import React from "react";
import "../NagthaneComponent/NagthaneCss/SarpanchDataGrid.css";
import govtImg from "../Images/sarpanchdataimg1.png";
import privateImg from "../Images/sarpanchdataimg.png";

export default function SarpanchDataGrid() {
  return (
    <section className="sarpanchdata-wrapper">
      <div className="sarpanchdata-grid">
        <img src={govtImg} alt="Sarpanch Data Image 1" />
        <img src={privateImg} alt="Sarpanch Data Image 2" />
      </div>
    </section>
  );
}
